module.exports = __webpack_public_path__ + "static/media/Peasant_wName.bbb7ce66.png";